
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/investor/events",
      function () {
        return require("private-next-pages/investor/events.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/investor/events"])
      });
    }
  